<template>
  <el-dialog
    :model-value="props.visible"
    :title="props.title"
    :width="props.width"
    @close="handleClose"
  >
    <component
      :is="currentComponent"
      v-if="props.visible"
    />
    <el-button
      type="default"
      size="default"
      style="margin-top: 10px"
      @click="handleClose"
      >Cerrar</el-button
    >
  </el-dialog>
</template>

<script setup>
import {
  markRaw,
  computed,
} from 'vue';
import AdditionalSettingsConcepts from './additional_settings_concepts.vue';
import AdditionalSettingsDeposits from './additional_settings_deposits.vue';
import AdditionalSettingsReceiptBooks from './additional_settings_receipt_books.vue';
import AdditionalSettingsLocations from './additional_settings_locations.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  component: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    default: 500,
  },
});

const emit = defineEmits(['closeModal']);

const componentsMap = {
  AdditionalSettingsConcepts,
  AdditionalSettingsDeposits,
  AdditionalSettingsReceiptBooks,
  AdditionalSettingsLocations,
};

const currentComponent = computed(() => {
  return markRaw(componentsMap[props.component]);
});

const handleClose = () => {
  emit('closeModal');
};
</script>
